import { _ as j, b as i, i as O, c as D } from "./isObjectLike.YJTOHc8M.js";
function L(r) {
  var e = typeof r;
  return r != null && (e == "object" || e == "function");
}
var F = L, G = j, K = F, W = "[object AsyncFunction]", R = "[object Function]", J = "[object GeneratorFunction]", q = "[object Proxy]";
function H(r) {
  if (!K(r))
    return !1;
  var e = G(r);
  return e == R || e == J || e == W || e == q;
}
var N = H, X = i, z = X["__core-js_shared__"], Q = z, $ = Q, w = function() {
  var r = /[^.]+$/.exec($ && $.keys && $.keys.IE_PROTO || "");
  return r ? "Symbol(src)_1." + r : "";
}();
function Y(r) {
  return !!w && w in r;
}
var Z = Y, rr = Function.prototype, er = rr.toString;
function tr(r) {
  if (r != null) {
    try {
      return er.call(r);
    } catch {
    }
    try {
      return r + "";
    } catch {
    }
  }
  return "";
}
var C = tr, ar = N, or = Z, nr = F, sr = C, ir = /[\\^$.*+?()[\]{}|]/g, cr = /^\[object .+?Constructor\]$/, ur = Function.prototype, vr = Object.prototype, gr = ur.toString, br = vr.hasOwnProperty, pr = RegExp(
  "^" + gr.call(br).replace(ir, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function fr(r) {
  if (!nr(r) || or(r))
    return !1;
  var e = ar(r) ? pr : cr;
  return e.test(sr(r));
}
var yr = fr;
function jr(r, e) {
  return r?.[e];
}
var $r = jr, Tr = yr, _r = $r;
function lr(r, e) {
  var a = _r(r, e);
  return Tr(a) ? a : void 0;
}
var v = lr, dr = v, Ar = i, Or = dr(Ar, "Map"), mr = Or, wr = j, Pr = O, Sr = "[object Arguments]";
function xr(r) {
  return Pr(r) && wr(r) == Sr;
}
var hr = xr, P = hr, Mr = O, V = Object.prototype, kr = V.hasOwnProperty, Ir = V.propertyIsEnumerable, Er = P(/* @__PURE__ */ function() {
  return arguments;
}()) ? P : function(r) {
  return Mr(r) && kr.call(r, "callee") && !Ir.call(r, "callee");
}, ot = Er, f = { exports: {} };
function Fr() {
  return !1;
}
var Nr = Fr;
f.exports;
(function(r, e) {
  var a = i, n = Nr, o = e && !e.nodeType && e, g = o && !0 && r && !r.nodeType && r, u = g && g.exports === o, b = u ? a.Buffer : void 0, p = b ? b.isBuffer : void 0, m = p || n;
  r.exports = m;
})(f, f.exports);
var nt = f.exports, Cr = 9007199254740991;
function Vr(r) {
  return typeof r == "number" && r > -1 && r % 1 == 0 && r <= Cr;
}
var B = Vr, Br = j, Ur = B, Dr = O, Lr = "[object Arguments]", Gr = "[object Array]", Kr = "[object Boolean]", Wr = "[object Date]", Rr = "[object Error]", Jr = "[object Function]", qr = "[object Map]", Hr = "[object Number]", Xr = "[object Object]", zr = "[object RegExp]", Qr = "[object Set]", Yr = "[object String]", Zr = "[object WeakMap]", re = "[object ArrayBuffer]", ee = "[object DataView]", te = "[object Float32Array]", ae = "[object Float64Array]", oe = "[object Int8Array]", ne = "[object Int16Array]", se = "[object Int32Array]", ie = "[object Uint8Array]", ce = "[object Uint8ClampedArray]", ue = "[object Uint16Array]", ve = "[object Uint32Array]", t = {};
t[te] = t[ae] = t[oe] = t[ne] = t[se] = t[ie] = t[ce] = t[ue] = t[ve] = !0;
t[Lr] = t[Gr] = t[re] = t[Kr] = t[ee] = t[Wr] = t[Rr] = t[Jr] = t[qr] = t[Hr] = t[Xr] = t[zr] = t[Qr] = t[Yr] = t[Zr] = !1;
function ge(r) {
  return Dr(r) && Ur(r.length) && !!t[Br(r)];
}
var be = ge;
function pe(r) {
  return function(e) {
    return r(e);
  };
}
var fe = pe, y = { exports: {} };
y.exports;
(function(r, e) {
  var a = D, n = e && !e.nodeType && e, o = n && !0 && r && !r.nodeType && r, g = o && o.exports === n, u = g && a.process, b = function() {
    try {
      var p = o && o.require && o.require("util").types;
      return p || u && u.binding && u.binding("util");
    } catch {
    }
  }();
  r.exports = b;
})(y, y.exports);
var ye = y.exports, je = be, $e = fe, S = ye, x = S && S.isTypedArray, Te = x ? $e(x) : je, st = Te, _e = Object.prototype;
function le(r) {
  var e = r && r.constructor, a = typeof e == "function" && e.prototype || _e;
  return r === a;
}
var de = le;
function Ae(r, e) {
  return function(a) {
    return r(e(a));
  };
}
var Oe = Ae, me = Oe, we = me(Object.keys, Object), Pe = we, Se = de, xe = Pe, he = Object.prototype, Me = he.hasOwnProperty;
function ke(r) {
  if (!Se(r))
    return xe(r);
  var e = [];
  for (var a in Object(r))
    Me.call(r, a) && a != "constructor" && e.push(a);
  return e;
}
var it = ke, Ie = N, Ee = B;
function Fe(r) {
  return r != null && Ee(r.length) && !Ie(r);
}
var ct = Fe, Ne = v, Ce = i, Ve = Ne(Ce, "DataView"), Be = Ve, Ue = v, De = i, Le = Ue(De, "Promise"), Ge = Le, Ke = v, We = i, Re = Ke(We, "Set"), Je = Re, qe = v, He = i, Xe = qe(He, "WeakMap"), ze = Xe, T = Be, _ = mr, l = Ge, d = Je, A = ze, U = j, c = C, h = "[object Map]", Qe = "[object Object]", M = "[object Promise]", k = "[object Set]", I = "[object WeakMap]", E = "[object DataView]", Ye = c(T), Ze = c(_), rt = c(l), et = c(d), tt = c(A), s = U;
(T && s(new T(new ArrayBuffer(1))) != E || _ && s(new _()) != h || l && s(l.resolve()) != M || d && s(new d()) != k || A && s(new A()) != I) && (s = function(r) {
  var e = U(r), a = e == Qe ? r.constructor : void 0, n = a ? c(a) : "";
  if (n)
    switch (n) {
      case Ye:
        return E;
      case Ze:
        return h;
      case rt:
        return M;
      case et:
        return k;
      case tt:
        return I;
    }
  return e;
});
var ut = s;
export {
  ut as _,
  nt as a,
  st as b,
  ot as c,
  de as d,
  it as e,
  F as f,
  B as g,
  v as h,
  ct as i,
  mr as j
};
//# sourceMappingURL=_getTag.B1GM_Sq5.js.map
